import { Backdrop, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(() => ({
  centered: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export default function LoaderWithBackdrop({
  isAbsolute = false,
  loadingMessage = "",
}) {
  const classes = useStyles();
  return (
    <div className="backdrop-loader">
      <Backdrop
        sx={{
          backgroundColor: "#ffffff9e !important",
          opacity: "1 !important",
          visibility: "visible !important",
          zIndex: "1000 !important",
          position: isAbsolute ? "absolute" : "fixed",
        }}
      >
        <div
          className={classes.centered}
          style={{
            position: isAbsolute ? "absolute" : "fixed",
          }}
        >
          <CircularProgress color="primary" />
        </div>
        {loadingMessage && <div className={"mt-5 pt-4"}>{loadingMessage}</div>}
      </Backdrop>
    </div>
  );
}
